import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";

import { NG_VALUE_ACCESSOR } from "@angular/forms";

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectDateComponent),
  multi: true,
};

@Component({
  selector: "select-date",
  templateUrl: "./select-date.component.html",
  styleUrls: ["./select-date.component.scss"],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class SelectDateComponent implements OnInit {
  public date: Date;
  @ViewChild("dateInputElement") public dateInputElement: ElementRef;
  @Input("appearance") public appearance:
    | "left-square"
    | "right-square"
    | "fromTo"
    | "thin"
    | "" = "";
  @Output("select-date-event")
  public menuEvent: EventEmitter<Date> = new EventEmitter<Date>();

  public onTouchedCallback: () => void = () => {};

  public onChangeCallback: (_: any) => void = () => {};

  // tslint:disable-next-line:no-empty
  public ngOnInit(): void {}

  public dateChanged($event: any) {
    // if ($event) {
    // } else {
    // }
  }

  public clickOnAllDates() {
    this.dateInputElement.nativeElement.showPicker();
  }

  //From ControlValueAccessor interface
  private registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  private registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private writeValue(value: Date) {
    this.date = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/form/select-date/select-date.component.ts